import * as React from "react"
import {Link} from "gatsby"
import "../../../images/logo-normal.png"

const Title = ({pageName}) => {
    return (
        <section className="wrapper">
            <div className="container pt-5 pb-6 pt-md-7 pb-md-8 text-center">
                <div className="row">
                    <div className="col-lg-8 mx-auto">
                        <h1 className="display-1 mb-3">
                            {pageName}
                        </h1>
                        <nav className="d-inline-block">
                            <Link to="/" className="text-black-50">
                                <span>
                                    <i className="bi bi-arrow-left text-orange"/>
                                </span>
                                <span>
                                    Back to Home Page
                                </span>
                            </Link>
                        </nav>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Title